import type { RfqType, VenueTraderInfo } from '@/legacy-api/orders-slice.gen'
import type { OrderSide } from '@/types/enums/order'
import type { Amount } from './order'

export interface RFQ {
  id: string
  client_rfq_id: string
  ib_id: string
  risk_group_id: string
  isin: string
  type: RFQType
  side: 'buy' | 'sell'
  amount: Amount
  venue_mpid: string
  disclosure: string
  expire_time?: string | null
  due_time?: string | null
  firm_until_time?: string | null
  settlement_date?: string | null
  created_at?: string | null
  status: string
  contra_quote_id?: string | null
  quotes: RFQQuote[]
  quote_responses: RFQQuoteResponse[]
  // Eventually use VenueTraderInfo from rafiqi
  venue_trader_info?: VenueTraderInfo
  skip_fees?: boolean
  list_id?: string | null
  list_name?: string | null
}

interface SpreadPrice {
  spread: number
  benchmark_isin: string
}

export interface RFQQuote {
  venue_quote_id: string
  side: 'buy' | 'sell'
  amount: Amount
  price: number
  ytw?: number | null
  ytm?: number | null
  spread_price: SpreadPrice | null
  firm_until_time?: string | null
  expire_time?: string | null
  counterparty?: string | null
  venue_mpid: string
  venue: string
  created_at?: string | null
  updated_at?: string | null
}

export enum RFQQuoteResponseStatus {
  Canceled = 'canceled',
  Rejected = 'rejected',
  Approved = 'approved',
}

export interface RFQQuoteResponse {
  id: string
  contra_quote_id: string
  client_order_id: string
  status: RFQQuoteResponseStatus
  created_at?: string | null
}

export enum RFQStatus {
  Open = 'open',
  Validating = 'validating',
  OrderPlaced = 'order_placed',
  Rejected = 'rejected',
  Expired = 'expired',
  Canceled = 'canceled',
  Filled = 'filled',
}

export enum RFQType {
  BIN = 'bin',
  ASAP = 'asap',
}

export enum DisclosureType {
  Disclosed = 'disclosed',
}

export interface CreateRFQRequest {
  client_rfq_id?: string
  ib_id: string
  risk_group_id: string
  custodian_id?: string
  instrument_id: string
  type: RfqType
  side: OrderSide
  amount: Amount
  venue_mpid: string
  disclosure: DisclosureType
  expire_time?: string
  due_time?: string
  firm_until_time?: string
  // ISO string (YYYY-MM-DD) — order creation still uses integer format via isoDateToInt
  settlement_date?: string | null
  moment_order_id?: string
  venue_trader_id?: string
  // Eventually use VenueTraderInfo from rafiqi
  venue_trader_info?: VenueTraderInfo
  skip_fees?: boolean
}

export interface CreateRFQResponse {
  rfq_id: string
}
